module.exports = __webpack_public_path__ + "static/media/19ESCAP36.1711f0f4.jpg";